"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _photographyClientLib = require("@wix/photography-client-lib");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenCartButton = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenCartButton, _React$Component);

  function FullscreenCartButton() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = FullscreenCartButton.prototype;

  _proto.getDefualtButtonText = function getDefualtButtonText() {
    return _photographyClientLib.translationUtils ? _photographyClientLib.translationUtils.getByKey('Gallery_ArtStore_UOU_Add_To_Cart_Button') : '';
  };

  _proto.render = function render() {
    var _this$props = this.props,
        cartItemsCount = _this$props.cartItemsCount,
        styleParams = _this$props.styleParams,
        mobileShopFrameOpen = _this$props.mobileShopFrameOpen,
        onAddToCartRequest = _this$props.onAddToCartRequest;
    var className = ['artstore-add-to-cart-button'];
    mobileShopFrameOpen && className.push('mobile-shop-frame-open');
    cartItemsCount ? className.push('pro-fullscreen-checkout-link-appears') : className.push('has-custom-focus');
    var buttonText = styleParams.addToCartButtonText || this.getDefualtButtonText();
    return /*#__PURE__*/_react["default"].createElement("button", {
      className: className.join(' '),
      tabIndex: 0,
      "aria-label": buttonText,
      onClick: onAddToCartRequest
    }, /*#__PURE__*/_react["default"].createElement("div", null, buttonText), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pro-fullscreen-overlay"
    }));
  };

  return FullscreenCartButton;
}(_react["default"].Component);

var _default = FullscreenCartButton;
exports["default"] = _default;